import { combineReducers } from 'redux'
import { reducer as formReducer } from 'redux-form'

import currency from './currencyReducer'
import dataIntegration from './dataIntegrationReducer'
import dataSource from './dataSourceReducer'
import documentStats from './documentStatsReducer'
import emailVerificationRequest from './emailVerification'
import expenseCategory from './expenseCategoryReducer'
import glCode from './glCodeReducer'
import global from './globalReducer'
import globalSearch from './globalSearchReducer'
import jobCode from './jobCodeReducer'
import ledger from './ledgerReducer'
import ledgerFilter from './ledgerFilterReducer'
import passwordReset from './passwordResetReducer'
import paymentMethod from './paymentMethodReducer'
import preferences from './preferenceReducer'
import receipt from './receiptReducer'
import recentExpense from './recentExpenseReducer'
import reports from './reportsReducer'
import searchVendor from './searchVendorReducer'
import session from './sessionReducer'
import signup from './signupReducer'
import snackbarNotification from './snackbarNotificationReducer'
import stats from './statsReducer'
import subscribe from './subscribeReducer'
import tags from './tagsReducer'
import uploadFile from './uploadFileReducer'
import user from './userReducer'
import userManagement from './userManagementReducer'
import vendor from './vendorReducer'
import vendors from './vendorsReducer'
import inbox from './inboxReducer'
import workflowStatus from './workflowStatusReducer'
import reconciliation from './reconciliationReducer'
import workFlowStep from './workFlowStepReducer'
import propertyName from './propertyNameReducer'
import unitNo from './unitNoReducer'
import entity from './entityReducer'
import department from './departmentReducer'
import purchaseOrders from './purchaseOrdersReducer'
import accountSettings from './accountSettingsReducer'

const appReducer = combineReducers({
  currency,
  dataIntegration,
  dataSource,
  documentStats,
  emailVerificationRequest,
  expenseCategory,
  form: formReducer,
  glCode,
  global,
  globalSearch,
  jobCode,
  ledger,
  ledgerFilter,
  passwordReset,
  paymentMethod,
  preferences,
  receipt,
  recentExpense,
  reports,
  searchVendor,
  session,
  signup,
  snackbarNotification,
  stats,
  subscribe,
  tags,
  uploadFile,
  user,
  userManagement,
  vendor,
  vendors,
  inbox,
  workflowStatus,
  reconciliation,
  workFlowStep,
  propertyName,
  unitNo,
  entity,
  department,
  purchaseOrders,
  accountSettings,
})

export default (state, action) => {
  if (action.type === 'CLEAR_APP_STATE') {
    state = undefined
  }

  return appReducer(state, action)
}
